<nav id="menu-support" trapFocus (keyup.escape)="close()">
    <div id="support-header">
        <i class="fa-regular fa-comment-question"></i>
        <p>{{ 'profileMenu.supportPanelHeader' | translate }}</p>
    </div>
    <a
        id="support-hub-link"
        [href]="supportHubUrl"
        target="_blank"
        autofocus
        tabindex="1"
        (click)="logHelpAndSupportTag('Support Hub')">
        <div class="btn-icon" id="support-hub-icon">
            <i class="fa-light fa-circle-question"></i>
        </div>
        <label for="support-hub-icon" id="support-hub-label">{{ 'supportMenu.supportHub' | translate }}</label>
    </a>
    <a id="phone" tabindex="2">
        <div class="btn-icon" id="phone-icon">
            <i class="fa-light fa-phone"></i>
        </div>
        <label for="phone-icon" id="phone-label">1-888-321-2113</label>
    </a>
    <a id="email" href="mailto:help@transnetyx.com" tabindex="3" (click)="logHelpAndSupportTag('Help Mail')">
        <div class="btn-icon" id="email-icon">
            <i class="fa-light fa-envelope"></i>
        </div>
        <label for="email-icon" id="email-label">Help&#64;transnetyx.com</label>
    </a>
    <a id="chat" class="hf-chat" (click)="openChat()" tabindex="4" (keyup.enter)="openChat()">
        <div class="btn-icon" id="chat-icon">
            <i class="fa-light fa-comments"></i>
        </div>
        <label for="chat-icon" id="chat-label">{{ 'supportMenu.liveChat' | translate }}</label>
    </a>
    <a id="terms-of-use-link" [href]="termsOfUseUrl" target="_blank" tabindex="5">
        <div class="btn-icon" id="terms-of-use-icon">
            <i class="fa-light fa-file-contract"></i>
        </div>
        <label for="terms-of-use-icon" id="terms-of-use-label">{{ 'supportMenu.termsOfUse' | translate }}</label>
    </a>
</nav>
